(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-check-availabilty"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Redirect immediately if postcode is already validated
    if (sessionStorage.getItem('postcodeValid') === 'true') {
      window.location.href = '/collections/main-dishes';
      return; // Stop further execution to ensure redirect happens
    }
    const form = document.querySelector('.signup-start__fields form');
    const postcodeInput = document.querySelector('.field__postcode');
    const postcodeErrorMessage = document.querySelector('.postcode-response');

    function validatePostcode(postcode) {
      const editablePostcodes = document.getElementById('thePostcodes').value;
      const validPostcodes = editablePostcodes.split(',').map((postcode) => postcode.trim());
      console.log(validPostcodes);
      if (validPostcodes.includes(postcode)) {
        postcodeErrorMessage.innerHTML = "Great! Let's get started.";
        return true;
      } else {
        postcodeErrorMessage.innerHTML =
          'Sorry - looks like that postcode is not eligible for FED deliveries. <a href="/pages/notify" style="color:inherit">Click here</a> to find out when shipping becomes available in your area.';
        return false;
      }
    }

    function checkFormValidity(event) {
      event.preventDefault(); // Always prevent form submission
      const postcodeValid = validatePostcode(postcodeInput.value);
      if (postcodeValid) {
        sessionStorage.setItem('postcodeValid', 'true');
        sessionStorage.setItem('postcode', postcodeInput.value);
        // Redirect to the new page if the postcode is valid
        setTimeout(() => {
          window.location.href = '/collections/main-dishes';
        }, 1000);
      }
    }

    form.addEventListener('submit', checkFormValidity);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-postcode-checker"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.signup-start__fields form');
    const postcodeInput = document.querySelector('.field__postcode');
    const postcodeErrorMessage = document.querySelector('.postcode-response');

    function validatePostcode(postcode) {
      const editablePostcodes = document.getElementById('thePostcodes').value;
      const validPostcodes = editablePostcodes.split(',').map((postcode) => postcode.trim());
      console.log(validPostcodes);
      if (validPostcodes.includes(postcode)) {
        postcodeErrorMessage.innerHTML = 'Great! This postcode is eligible for FED deliveries.';
        return true;
      } else {
        postcodeErrorMessage.innerHTML =
          'Sorry - looks like that postcode is not eligible for FED deliveries. <a href="/pages/notify" style="color:inherit">Click here</a> to find out when shipping becomes available in your area.';
        return false;
      }
    }

    function checkFormValidity(event) {
      event.preventDefault(); // Always prevent form submission
      const postcodeValid = validatePostcode(postcodeInput.value);
      if (postcodeValid) {
        sessionStorage.setItem('postcodeValid', 'true');
        sessionStorage.setItem('postcode', postcodeInput.value);
      }
    }

    form.addEventListener('submit', checkFormValidity);
  });

  } catch(e) { console.error(e); }
})();
})();
